import React, { useEffect, useRef, useState } from "react";
import TabCompo from "../component/TabCompo";
import { useSelector } from "react-redux";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { GoFile } from "react-icons/go";
import { MdOutlineFileDownload } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
import { SERVER_URL } from "../constant";
import { FiUpload } from "react-icons/fi";
import DialogBox from "../component/DialogBox";
import ButtonCompo from "../component/ButtonCompo";
import AlertBox from "../component/AlertBox";
import dayjs from "dayjs";
import { FiAlertCircle } from "react-icons/fi";
import { IoMdAlert } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { BiSolidError } from "react-icons/bi";

function MyDocs() {
  const employeeData = useSelector((state) => state.employee?.employeeData);
  let allDocs = [];
  const docsArray = [
    {
      name: "tenThCert",
      title: "10th Certificate",
    },
    {
      name: "upiQrCode",
      title: "UPI QR Code",
    },
    {
      name: "twelevThCert",
      title: "12th Certificate",
    },
    {
      name: "gradCert",
      title: "Graduation Certificate",
    },
    {
      name: "postGradCert",
      title: "Post Graduation Certificate",
    },
    {
      name: "diplomaCert",
      title: "Diploma Certficate",
    },
    {
      name: "panCard",
      title: "PAN Card",
    },
    {
      name: "aadharCard",
      title: "AADHAR Card",
    },
    {
      name: "bankDetails",
      title: "Bank Details",
    },
    {
      name: "cv",
      title: "CV",
    },
    {
      name: "prevOfferLetter",
      title: "Previous Company's Offer Letter",
    },
    {
      name: "prevHikeLetter",
      title: "Previous Company's Hike Letter",
    },
    {
      name: "prevExpLetter",
      title: "Previous Company's Experience Letter",
    },
    {
      name: "prevPayslips",
      title: "Last 3 months payslip of previous company",
    },
    {
      name: "prevRelivingLetter",
      title: "Previous Company's Reliving Letter",
    },
  ].map((doc) => {
    if (employeeData !== null && employeeData[doc?.name] !== undefined) {
      const newObj = { ...doc, link: employeeData[doc?.name] };
      allDocs.push(newObj);
    }
  });
  return (
    <>
      <div className="w-full border mt-5">
        {allDocs?.map((e, i) => (
          <div className="flex justify-between items-center px-5 py-4 border-b-[1px]">
            <div className="flex gap-3 items-center">
              <span className="bg-slate-200/50 p-2 rounded-full">
                <GoFile className="text-[20px] text-slate-800" />
              </span>
              <div>
                <p className="text-[15px] font-medium text-slate-700">
                  {e?.title}
                </p>
              </div>
            </div>
            <Link
              className="flex gap-2 items-center bg-blue-200/30 font-medium px-2 rounded-[5px] text-blue-600/90 justify-center py-2"
              to={`${SERVER_URL}/api/v1/file/view/${e?.link}`}
              target="_blank"
            >
              <MdOutlineFileDownload size={"20px"} /> Download
            </Link>
          </div>
        ))}
      </div>
    </>
  );
}

function HrDocs() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [hrDocuments, setHrDocuments] = useState([]);
  const [file, setFile] = useState(null);
  const fileRef = useRef(null);
  const [reload, setReload] = useState(false);

  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/user/employee`,
        method: "get",
        withCredentials: true,
      });
      // console.log(res.data?.data?.hrDocs);
      const rawData = res.data?.data?.hrDocs;
      let finalData = [];
      if (Array.isArray(rawData)) {
        rawData.map((data, i) => {
          const now = dayjs();
          const targetedDate = dayjs(data?.expiryDate);
          let obj = {};
          console.log(targetedDate.isBefore(now));
          if (targetedDate.isBefore(now)) {
            obj = { ...data, datePassed: true };
          } else {
            obj = { ...data, datePassed: false };
          }
          finalData.push(obj);
        });
      }
      setHrDocuments(finalData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Employee fetch failed");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getEmployee();
  }, [reload]);

  //add doc
  async function addDoc(title) {
    if (file === null) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the fields and choose a file");
      return null;
    }
    const formData = new FormData();
    formData.append("employee_doc", file);
    formData.append("title", title);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/hr/document/upload`,
        method: "post",
        withCredentials: true,
        data: formData,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Document added successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // acknowledgement
  async function changeAckStatus(title, ackStatus) {
    if (title?.length === 0 || ackStatus?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Title or status not found");
      return null;
    }
    const data = {
      title: title,
      status: ackStatus,
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/hr/docs/acknowledgement`,
        method: "post",
        withCredentials: true,
        data: data,
      });
      setOpen(true);
      setSuccess(true);
      setMessage("Status has been changed successfully");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Status change failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full py-5">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <Table>
          {hrDocuments?.length === 0 && (
            <div>
              <h1 className="text-center mt-3 text-[18px] text-slate-400 font-semibold">No documents added yet</h1>
            </div>
          )}
          <TableBody className="border">
            {hrDocuments?.map((e, i) => (
              <TableRow>
                <TableCell>
                  <div className="flex gap-3 items-center">
                    <span>
                      {e?.status === "Waiting" ? (
                        <IoMdAlert size={23} className="text-yellow-500" />
                      ) : e?.status === "Denied" ? (
                        <BiSolidError size={23} className="text-red-500" />
                      ) : (
                        <FaCheckCircle size={23} className="text-green-500" />
                      )}
                    </span>
                    <div className="w-[15rem]">
                      <p className="font-medium">
                        {e?.title}{" "}
                        <Link
                          className="ml-2 bg-blue-200/60 px-3 py-1 rounded-full font-medium text-blue-600"
                          to={`${SERVER_URL}/api/v1/file/view/${e?.hrFile}`}
                          target="_blank"
                        >
                          View
                        </Link>
                      </p>
                      <p className="text-slate-500 mt-2">{e?.description}</p>
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  Uploaded At{" "}
                  <span className="bg-slate-200/70 px-3 py-1 rounded-full text-slate-700 font-medium">
                    {new Date(e?.date).toLocaleDateString("en-US", {
                      timeZone: "Asia/Kolkata",
                    })}
                  </span>
                </TableCell>
                <TableCell>
                  Last Date of Acknowledgement{" "}
                  <span className="bg-slate-200/70 px-3 py-1 rounded-full text-slate-700 font-medium">
                    {new Date(e?.expiryDate).toLocaleDateString("en-US", {
                      timeZone: "Asia/Kolkata",
                    })}
                  </span>
                  {e?.datePassed === true && e?.status === "Waiting" ? (
                    <section className="flex items-center gap-1 mt-2 text-red-500">
                      <span>
                        <FiAlertCircle size={17} className="text-red-500" />
                      </span>
                      Last date of acknowledgement has been passed. Please
                      contact to your HR.
                    </section>
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell>
                  <ButtonCompo
                    variant={"contained"}
                    color={"success"}
                    disabled={
                      e?.status === "Waiting" && !e?.datePassed ? false : true
                    }
                    onClick={() => changeAckStatus(e?.title, "Acknowledged")}
                  >
                    Acknowledge
                  </ButtonCompo>
                </TableCell>
                <TableCell>
                  <ButtonCompo
                    color={"error"}
                    disabled={
                      e?.status === "Waiting" && !e?.datePassed ? false : true
                    }
                    onClick={() => changeAckStatus(e?.title, "Denied")}
                  >
                    Decline
                  </ButtonCompo>
                </TableCell>
                <TableCell>
                  {e?.employeeUpload === true ? (
                    <DialogBox
                      trigger={
                        <div className="flex gap-3 w-[10rem] items-center cursor-pointer bg-blue-200/30 p-2 rounded-[10px] text-blue-600/90 font-medium justify-center">
                          <span className="">
                            <FiUpload className="text-[18px]" />
                          </span>
                          Upload
                        </div>
                      }
                      title="Upload Your Document"
                      actionButton={
                        <ButtonCompo onClick={() => addDoc(e?.title)}>
                          Save
                        </ButtonCompo>
                      }
                      closeActionButton={<ButtonCompo>close</ButtonCompo>}
                    >
                      <div className="w-full space-y-3">
                        <input
                          type="file"
                          className="hidden"
                          ref={fileRef}
                          onChange={(event) => setFile(event?.target?.files[0])}
                        />
                        <section
                          onClick={() => fileRef.current.click()}
                          className="bg-slate-100/10 py-5 flex justify-center px-3 items-center w-full border border-dashed border-slate-400/80 rounded-[5px] cursor-pointer"
                        >
                          <p className="text-slate-800/80 text-[15.5px] flex flex-col justify-center items-center gap-1 font-medium">
                            Upload Document
                            {file !== null && (
                              <span className="text-slate-500">
                                1 document selected
                              </span>
                            )}
                          </p>
                        </section>
                      </div>
                    </DialogBox>
                  ) : (
                    <div className="flex gap-3 w-[10rem] items-center cursor-pointer bg-slate-200/30 p-2 rounded-[10px] text-slate-600/50 font-medium justify-center">
                      <span className="">
                        <FiUpload className="text-[18px]" />
                      </span>
                      Upload
                    </div>
                  )}
                </TableCell>
                <TableCell>
                  {e?.employeeFile === undefined ? (
                    <span className="flex gap-2 w-[10rem] items-center bg-slate-200/30 font-medium px-2 rounded-[5px] text-slate-600/50 justify-center py-2">
                      <MdOutlineFileDownload size={"20px"} /> Sent
                    </span>
                  ) : (
                    <Link
                      className="flex gap-2 w-[10rem] items-center bg-blue-200/30 font-medium px-2 rounded-[5px] text-blue-600/90 justify-center py-2"
                      to={`${SERVER_URL}/api/v1/file/view/${e?.employeeFile}`}
                      target="_blank"
                    >
                      <MdOutlineFileDownload size={"20px"} /> Sent
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
}

function EmployeeDocuments() {
  const tabArray = [
    {
      title: "My Documents",
      component: <MyDocs />,
    },
    {
      title: "HR Documents",
      component: <HrDocs />,
    },
  ];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90vw] py-5">
        <div className="mt-5 w-full">
          <TabCompo tabArray={tabArray} />
        </div>
      </div>
    </div>
  );
}

export default EmployeeDocuments;
